import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';
import { UserLoginModel } from '../model/user-login-model';
import { ApiResponseModel } from '../model/api-response-model';
import { VMS_USER_MASTER } from '../model/user-registration-model';
import { VendorsignUpModel } from '../model/vendorsign-up-model';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private crudeSer:CrudService) {
  
   }
   Login(UserName:any,Password:any): Observable<any> {
    return this.crudeSer.get<any>('User/GetUserById?UserName='+UserName+'&Password='+Password); 
  } 
  ForgotPassword(Username:any): Observable<any> {
    return this.crudeSer.get<any>('User/ForgotPassword?UserName='+Username); 
  } 
  GetAllUserList(): Observable<ApiResponseModel> {
    return this.crudeSer.get<any>('User/GetAllusers');
  } 
  SaveUserRecord(model:VMS_USER_MASTER): Observable<ApiResponseModel>{
    return this.crudeSer.post<any>('User/SaveUser', model);
  }
  UpdateUserRecord(model:VMS_USER_MASTER): Observable<ApiResponseModel>{
    return this.crudeSer.post<any>('User/UpdateUser', model);
  }
  RegisterVendor(model:VendorsignUpModel): Observable<ApiResponseModel>{
    return this.crudeSer.post<any>('User/RegisterUser', model);
  }
  CheckExistingVendor(model:any): Observable<ApiResponseModel>{
    return this.crudeSer.post<any>('User/CheckVendroExistance', model);
  }


  DeactivateUserRecord(model:VMS_USER_MASTER): Observable<ApiResponseModel>{
    return this.crudeSer.post<any>('User/DeactivateUser', model);
  }
  GetCityandState(): Observable<ApiResponseModel> {
    return this.crudeSer.get<any>('User/GetPostandCityCode');
  } 

  GetState(): Observable<ApiResponseModel> {
    return this.crudeSer.get<any>('User/GetState');
  } 

  GetPostCode(): Observable<ApiResponseModel> {
    return this.crudeSer.get<any>('User/GetPostCode');
  } 

  GetDepartmentCode(): Observable<ApiResponseModel> {
    return this.crudeSer.get<any>('User/GetDepartmentCode');
  } 

  GetVendorDetails(): Observable<ApiResponseModel> {
    return this.crudeSer.get<any>('User/GetVendorDetails');
  } 


  UploadDeclaration(model:any): Observable<ApiResponseModel>{
    return this.crudeSer.post<any>('User/UploadDeclaration', model);
  }

  UpdateDeclaration(model:any): Observable<ApiResponseModel>{
    return this.crudeSer.post<any>('User/UpdateDeclaration', model);
  }

  ResetPassword(UserName,Password,Newpassword): Observable<any>{ 
    return this.crudeSer.get('User/ResetPassword?UserName=' + UserName+"&Password="+Password+"&Newpassword="+Newpassword);
  }

  SaveMSMEDetails(model:any): Observable<ApiResponseModel>{
    return this.crudeSer.post<any>('User/SaveMSMEDetails', model);
  }
  
}
